import Vue from 'vue';
import { BfSpinner } from 'components/Butterfly';
import ObjectBrowser from 'components/project/create/ObjectBrowser.vue';
import ToggleSlider from 'components/widgets/ToggleSlider.vue';
import FormatUtils from 'src/utils/formatters';
export default Vue.extend({
    name: "AutoAddSettings",
    components: { ObjectBrowser, BfSpinner, ToggleSlider },
    props: {
        isLoading: { type: Boolean, default: false },
        integrationType: { type: String, default: '' },
        integrationInfo: { type: Object, default: () => ({}) },
        autoAddFilesEnabled: { type: Boolean, required: true },
        autoAddInterval: { type: String, default: '' },
        nextAutoAddTime: { type: String, default: '' },
        lastSucceededTime: { type: String, default: '' },
        lastRunTime: { type: String, default: '' },
        integrationDescription: { type: String, default: '' },
        autoAddPartials: { type: Boolean, default: undefined },
        integrationBucket: { type: String, default: '' },
        selectedFolder: { type: String, default: '' },
        uniqueFields: { type: Array, default: () => [] },
        autoAddIntervalOptions: { type: Array, default: () => [] }
    },
    data() {
        return {
            showFileBrowser: false,
        };
    },
    computed: {
        formatedDescription() {
            return this.integrationDescription.replace(/\r\n|\r|\n/g, '<br>');
        },
        toggleMsg() {
            if (this.integrationType === 'survey_monkey') {
                return "Automatically add new responses from Survey Monkey to your project";
            }
            else if (this.integrationType === 'qualtrics') {
                return "Automatically import new responses from Qualtrics";
            }
            else if (this.integrationType === 's3') {
                return "Automatically add & update data files from an S3 folder";
            }
            else if (this.integrationType === 'gcs') {
                return "Automatically add & update data files from an GCS folder";
            }
            return '';
        },
        autoAddPartialsEnabled() {
            if (!this.autoAddFilesEnabled) {
                return {
                    enabled: false,
                    helpMsg: 'Automatic imports must be enabled to turn this feature on.',
                };
            }
            if (this.uniqueFields.length === 0) {
                return {
                    enabled: false,
                    helpMsg: 'Importing partially complete responses can not be enabled for this project. This feature is '
                        + 'only available for projects that were created with a unique row identifier. This is to '
                        + 'prevent importing the same survey response multiple times.'
                };
            }
            return { enabled: true, helpMsg: '' };
        },
        timezone() {
            const date = new Date();
            const timezone = date.toTimeString().split(" ")[1].slice(0, -2);
            return timezone;
        }
    },
    methods: {
        formatDateTime: FormatUtils.formatDateTime,
        formatInterval: FormatUtils.formatInterval,
    }
});
